import React from 'react';
import { Loader2, RefreshCcw, ShoppingCart } from 'lucide-react';

import { getGroupKey } from './historyUtils';

const HistoryGroupEbaySection = ({
  group,
  ebaySearchingGroup,
  ebayResultsMap,
  onSearchEbay,
}) => {
  const groupKey = getGroupKey(group);
  const ebayResults = ebayResultsMap[groupKey] || group.items[0]?.ebay_results;
  const isSearching = ebaySearchingGroup === groupKey;

  return (
    <>
      <div className="hidden sm:block border-t border-hairline p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <ShoppingCart size={14} className="text-accent" />
            <span className="text-xs font-bold text-muted uppercase tracking-wider">eBay Similar Items</span>
          </div>
          <button
            onClick={() => onSearchEbay(group)}
            disabled={isSearching}
            className="flex items-center gap-1 text-xs px-2 py-1 bg-accent/10 text-accent border border-accent/30 rounded hover:bg-accent/20 transition-colors disabled:opacity-50"
          >
            {isSearching ? <Loader2 size={12} className="animate-spin" /> : <RefreshCcw size={12} />}
            {isSearching ? 'Searching...' : ebayResults ? 'Re-search' : 'Search eBay'}
          </button>
        </div>
        {isSearching && !ebayResults && (
          <p className="text-xs text-muted italic">Searching eBay for similar items...</p>
        )}
        {ebayResults && Array.isArray(ebayResults) && ebayResults.length === 0 && (
          <p className="text-xs text-muted italic">No similar items found.</p>
        )}
        {ebayResults && Array.isArray(ebayResults) && ebayResults.length > 0 && (
          <div className="flex gap-2 overflow-x-auto pb-1">
            {ebayResults.map((ebayItem, idx) => (
              <a
                key={ebayItem.itemId || idx}
                href={ebayItem.itemWebUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 w-32 bg-surface border border-hairline rounded overflow-hidden hover:shadow-md hover:border-accent transition-all group"
              >
                {ebayItem.image && (
                  <div className="aspect-square bg-surface-2 overflow-hidden">
                    <img src={ebayItem.image} alt={ebayItem.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                  </div>
                )}
                <div className="p-1.5">
                  <p className="text-[10px] text-muted line-clamp-2 mb-0.5">{ebayItem.title}</p>
                  <p className="text-xs font-bold text-positive">${ebayItem.price}</p>
                </div>
              </a>
            ))}
          </div>
        )}
        {!ebayResults && !isSearching && (
          <p className="text-xs text-muted italic">Click "Search eBay" to find similar items.</p>
        )}
      </div>

      <div className="sm:hidden border-t border-hairline p-3">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-1">
            <ShoppingCart size={12} className="text-accent" />
            <span className="text-[10px] font-bold text-muted uppercase">eBay</span>
          </div>
          <button
            onClick={() => onSearchEbay(group)}
            disabled={isSearching}
            className="flex items-center gap-1 text-[10px] px-2 py-0.5 bg-accent/10 text-accent border border-accent/30 rounded hover:bg-accent/20 transition-colors disabled:opacity-50"
          >
            {isSearching ? <Loader2 size={10} className="animate-spin" /> : <RefreshCcw size={10} />}
            {isSearching ? 'Searching...' : ebayResults ? 'Re-search' : 'Search'}
          </button>
        </div>
        {ebayResults && Array.isArray(ebayResults) && ebayResults.length > 0 && (
          <div className="flex gap-2 overflow-x-auto pb-1">
            {ebayResults.map((ebayItem, idx) => (
              <a
                key={ebayItem.itemId || idx}
                href={ebayItem.itemWebUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 w-24 bg-surface border border-hairline rounded overflow-hidden"
              >
                {ebayItem.image && (
                  <img src={ebayItem.image} alt={ebayItem.title} className="w-full aspect-square object-cover" />
                )}
                <div className="p-1">
                  <p className="text-[9px] text-muted line-clamp-1">{ebayItem.title}</p>
                  <p className="text-[10px] font-bold text-positive">${ebayItem.price}</p>
                </div>
              </a>
            ))}
          </div>
        )}
        {!ebayResults && !isSearching && (
          <p className="text-[10px] text-muted italic">Tap "Search" to find similar items on eBay.</p>
        )}
      </div>
    </>
  );
};

export default HistoryGroupEbaySection;
